module.exports = __webpack_public_path__ + "static/media/aac.c122b9ba.png";